/**
 * A helper function to check if the app is running in Electron env
 * Electron and the app name are revealed in the user agent
 * Ref: https://github.com/electron/electron/issues/2288#issuecomment-337858978
 */
const isElectron = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf(' electron/') > -1;
};

export default isElectron;
